import { Gender } from '@/data/enums';
import { addYears, parse } from 'date-fns';
import { getAgeInYearFromDate } from './date';
import { MAX_ANB } from '@/data/constants';

export const formatNric = (nric: string | undefined | null): string => {
  if (!nric) return '';
  const digits = String(nric).replace(/\D/g, '');
  if (digits.length !== 12) return nric;
  return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 12)}`;
};

export const getDateFromNric = (nric: string): Date => {
  const today = new Date();
  const date = parse(nric.slice(0, 6), 'yyMMdd', today);

  if (date.getFullYear() > today.getFullYear()) {
    date.setFullYear(date.getFullYear() - 100);
  }

  return date;
};

export const getGenderFromNric = (nric: string): Gender => {
  const lastDigit = +nric.charAt(nric.length - 1);
  return lastDigit % 2 === 0 ? Gender.FEMALE : Gender.MALE;
};

export const getTermFromDob = (
  dob: Date,
  maximum?: number,
  minimum?: number,
): Date => {
  const today = new Date();

  let age = getAgeInYearFromDate(dob);
  let totalTerm = 85 - age;
  if (minimum && maximum && (age <= minimum || age >= maximum)) {
    totalTerm = 0;
  }
  return addYears(today, totalTerm);
};

export const removeLeadingZero = (mobile: string) => {
  return mobile.replace(/^(60|0)/, '');
};

export const isBelowAnb = (nric: string) => {
  const dob = getDateFromNric(nric);
  const age = getAgeInYearFromDate(dob);
  const anb = age + 1;

  return anb <= MAX_ANB;
};

export const pickNricFieldFromError = (msg?: string) => {
  const m = msg?.match(/ErrorField\[(.*?)\]/);
  const field = m?.[1] ?? '';
  if (field.startsWith('A_PO_')) return 'policy_owner.nric' as const;
  if (field.startsWith('A_LI_')) return 'life_insured.nric' as const;
  return 'life_insured.nric' as const;
};
